var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "site-detail-dashboard" }, [
    _c(
      "div",
      { staticClass: "dashboard-grid" },
      [
        _c(
          "DashboardCard",
          {
            staticClass: "status-card",
            attrs: {
              icon: "dashboard",
              title: _vm.$t("adminPanel.siteDashboardSiteStatus"),
            },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": _vm.$t("message.active"),
                "un-checked-children": _vm.$t("message.passive"),
                size: "large",
              },
              model: {
                value: _vm.localEnable,
                callback: function ($$v) {
                  _vm.localEnable = $$v
                },
                expression: "localEnable",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "team",
              title: _vm.$t("adminPanel.siteDashboardAgents"),
            },
          },
          [
            _c("div", { staticClass: "metric-value" }, [
              _vm._v(_vm._s(_vm.site.agentCount)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "global",
              title: _vm.$t("adminPanel.siteDashboardDomainCount"),
            },
          },
          [
            _c("div", { staticClass: "metric-value" }, [
              _vm._v(_vm._s(_vm.site.integratedOrigins.length)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "eye",
              title: _vm.$t("adminPanel.siteDashboardRealtimeVisitor"),
              highlight: "",
            },
          },
          [
            _c("div", { staticClass: "metric-value realtime" }, [
              _vm._v(_vm._s(_vm.site.realtimeVisitorCount || 0)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "api",
              title: _vm.$t("adminPanel.siteDashboardIntegration"),
            },
          },
          [
            _c("a-badge", {
              attrs: {
                status: _vm.site.isIntegrated ? "success" : "error",
                text: _vm.site.isIntegrated
                  ? _vm.$t("message.active")
                  : _vm.$t("message.passive"),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "clock-circle",
              title: _vm.$t("adminPanel.siteDashboardLastActivity"),
            },
          },
          [
            _c("div", { staticClass: "metric-text" }, [
              _vm._v(_vm._s(_vm.lastActivity())),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            staticClass: "suspend-card",
            class: { "is-suspended": _vm.site.suspend },
            attrs: {
              icon: "lock",
              title: _vm.$t("adminPanel.siteDashboardSuspend"),
            },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": _vm.$t("message.active"),
                "un-checked-children": _vm.$t("message.passive"),
                size: "large",
              },
              model: {
                value: _vm.localSuspend,
                callback: function ($$v) {
                  _vm.localSuspend = $$v
                },
                expression: "localSuspend",
              },
            }),
            _vm._v(" "),
            _vm.site.suspendReason
              ? _c(
                  "div",
                  { staticClass: "suspend-reason" },
                  [
                    _c("a-tag", { attrs: { color: "red" } }, [
                      _vm._v(
                        _vm._s(_vm.getSuspendReasonText(_vm.site.suspendReason))
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            attrs: {
              icon: "solution",
              title: _vm.$t("adminPanel.siteDashboardPartner"),
            },
          },
          [
            _c("div", { staticClass: "metric-text" }, [
              _vm._v(
                _vm._s(
                  _vm.$_.get(_vm.site, "partner.name") ||
                    _vm.$t("adminPanel.siteDashboardNoPartner")
                )
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "DashboardCard",
          {
            staticClass: "blink-card",
            attrs: {
              icon: "notification",
              title: _vm.$t("adminPanel.siteDashboardBlink"),
            },
          },
          [
            _c("a-switch", {
              attrs: {
                "checked-children": _vm.$t("message.active"),
                "un-checked-children": _vm.$t("message.passive"),
                size: "large",
              },
              model: {
                value: _vm.localBlink,
                callback: function ($$v) {
                  _vm.localBlink = $$v
                },
                expression: "localBlink",
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "dollar" } }),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardBillingSettings"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-grid" },
        [
          _c("SettingCard", {
            attrs: {
              icon: "calendar",
              title: _vm.$t("adminPanel.siteDashboardTrialPeriod"),
              value: _vm.$t("adminPanel.siteDashboardTrialDays", {
                n: _vm.trialDay,
              }),
              "sub-value": _vm.$t("adminPanel.siteDashboardTrialRemaining", {
                n: _vm.getRemainingTrialDay(),
              }),
            },
            on: { edit: _vm.showTrialPrompt },
          }),
          _vm._v(" "),
          _c(
            "SettingCard",
            {
              staticClass: "payment-method-card",
              attrs: {
                icon: "credit-card",
                title: _vm.$t("adminPanel.siteDashboardPaymentMethod"),
              },
            },
            [
              _c(
                "a-radio-group",
                {
                  attrs: { "button-style": "solid" },
                  model: {
                    value: _vm.localPaymentMethod,
                    callback: function ($$v) {
                      _vm.localPaymentMethod = $$v
                    },
                    expression: "localPaymentMethod",
                  },
                },
                [
                  _c("a-radio-button", { attrs: { value: "credit-card" } }, [
                    _vm._v(
                      _vm._s(_vm.$t("adminPanel.siteDashboardCreditCard"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("a-radio-button", { attrs: { value: "eft" } }, [
                    _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardEft"))),
                  ]),
                  _vm._v(" "),
                  _c("a-radio-button", { attrs: { value: "btc" } }, [
                    _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardBtc"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "percentage",
              title: _vm.$t("adminPanel.siteDashboardTotalDiscount"),
              value: _vm.totalDiscount + "%",
            },
            on: { edit: _vm.showTotalDiscountPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "calendar",
              title: _vm.$t("adminPanel.siteDashboardInvoiceDueDays"),
              value: _vm.invoiceDueDays
                ? String(_vm.invoiceDueDays)
                : _vm.$t("adminPanel.siteDashboardInvoiceDueDefault"),
            },
            on: { edit: _vm.showInvoiceDueDaysPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "wallet",
              title: _vm.$t("adminPanel.siteDashboardWhatsappWallet"),
              value: _vm.whatsappWallet + " " + _vm.$t("adminPanel.currencyTL"),
            },
            on: { edit: _vm.showWhasappWalletPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "warning",
              title: _vm.$t("adminPanel.siteDashboardWhatsappLowLimit"),
              value: _vm.maxLowBalance + " " + _vm.$t("adminPanel.currencyTL"),
            },
            on: { edit: _vm.showWhasappLowLimitPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "mail",
              title: _vm.$t("adminPanel.siteDashboardMonthlyMailLimit"),
              value: String(_vm.monthlyMailSendLimit),
            },
            on: { edit: _vm.showMonthlyMailSendLimitPrompt },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "percentage" } }),
          _vm._v(" "),
          _c("h3", [
            _vm._v(
              _vm._s(_vm.$t("adminPanel.siteDashboardCommissionSettings"))
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "settings-grid" },
        [
          _c("SettingCard", {
            attrs: {
              icon: "whats-app",
              title: _vm.$t("adminPanel.siteDashboardSupsisWabaCommission"),
              value: _vm.supsisWabaCommission + "%",
            },
            on: { edit: _vm.showSupsisWabaCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "whats-app",
              title: _vm.$t("adminPanel.siteDashboardGupshupWabaCommission"),
              value: _vm.gupshupCommission + "%",
            },
            on: { edit: _vm.showGupshupCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "message",
              title: _vm.$t("adminPanel.siteDashboardGupshupCommission"),
              value: _vm.whatsappCommission + "%",
            },
            on: { edit: _vm.showWhatsappCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "robot",
              title: _vm.$t("adminPanel.siteDashboardOpenaiCommission"),
              value: _vm.aiUsageCommission + "%",
            },
            on: { edit: _vm.showOpenAICommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "phone",
              title: _vm.$t("adminPanel.siteDashboardAiCallCommission"),
              value: _vm.aiCallCommission + "%",
            },
            on: { edit: _vm.showAiCallCommissionPrompt },
          }),
          _vm._v(" "),
          _c("SettingCard", {
            attrs: {
              icon: "calculator",
              title: _vm.$t("adminPanel.siteDashboardVatRate"),
              value: _vm.vatRate + "%",
            },
            on: { edit: _vm.showVatRatePrompt },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings-section" }, [
      _c(
        "div",
        { staticClass: "section-header" },
        [
          _c("a-icon", { attrs: { type: "link" } }),
          _vm._v(" "),
          _c("h3", [
            _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardIntegrationInfo"))),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "integration-info" }, [
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("a-icon", { attrs: { type: "mobile" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [
              _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardMobile"))),
            ]),
            _vm._v(" "),
            _c("a-badge", {
              attrs: {
                status: _vm.site.mobileUserCount > 0 ? "success" : "error",
                text:
                  _vm.site.mobileUserCount > 0
                    ? _vm.$t("message.active")
                    : _vm.$t("message.passive"),
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-item" },
          [
            _c("a-icon", { attrs: { type: "global" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [
              _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardWebsite"))),
            ]),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "info-link",
                attrs: {
                  href:
                    (_vm.IS_DEV_ENVIRONMENT ? "http" : "https") +
                    "://" +
                    _vm.site.settings.website,
                  target: "_blank",
                },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.site.settings.website) +
                    "\n                    "
                ),
                _c("a-icon", { attrs: { type: "link" } }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "info-item full-width" },
          [
            _c("a-icon", { attrs: { type: "deployment-unit" } }),
            _vm._v(" "),
            _c("span", { staticClass: "info-label" }, [
              _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardWebsiteOrigins"))),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "origins-list" },
              _vm._l(_vm.site.integratedOrigins, function (dom, index) {
                return _c("div", { key: index, staticClass: "origin-item" }, [
                  _c(
                    "a",
                    {
                      staticClass: "origin-link",
                      attrs: {
                        href:
                          (_vm.IS_DEV_ENVIRONMENT ? "http" : "https") +
                          "://" +
                          dom,
                        target: "_blank",
                      },
                    },
                    [
                      _c("a-icon", { attrs: { type: "link" } }),
                      _vm._v(
                        "\n                            " +
                          _vm._s(dom) +
                          "\n                        "
                      ),
                    ],
                    1
                  ),
                ])
              }),
              0
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "danger-zone" },
      [
        _c(
          "div",
          { staticClass: "danger-header" },
          [
            _c("a-icon", { attrs: { type: "warning" } }),
            _vm._v(" "),
            _c("h3", [
              _vm._v(_vm._s(_vm.$t("adminPanel.siteDashboardDangerZone"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-button",
          {
            attrs: { type: "danger", size: "large" },
            on: {
              click: function ($event) {
                return _vm.$emit("delete-site", _vm.site)
              },
            },
          },
          [
            _c("a-icon", { attrs: { type: "delete" } }),
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("adminPanel.siteDashboardDeleteSite")) +
                "\n        "
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }